import styles from "./header-title.module.css"
import { Logo } from "../logo"
import { Back } from "../back-button"
import { useStoreShared } from "../../../../../store"
import logoTelekom from "../../../../../assets/images/Deutsche_Telekom.png"
interface Props {
  title: string | undefined
}
export function HeaderTitle({ title }: Props) {
  const { stateShared } = useStoreShared()
  // const isTelekom = sessionStorage.getItem("currentClientUuid") === "39d60ce7-6e1a-4cab-87ed-047e6323e262";
  return (
    <div className={styles.root}>
      {title !== stateShared.currentClient?.name && <Back></Back>}
      {title === stateShared.currentClient?.name && <Logo></Logo>}
      {!stateShared.clientConfig?.header.logo &&  <div className={styles.title}>{title}</div>}
      {stateShared.clientConfig?.header.logo &&  <div ><img className={styles.telekom_icon} src={stateShared.clientConfig?.header.logo}  /></div>}
    </div>
  )
}
